import styled from 'styled-components';

const Text = styled.div`
  .form-item-counter {
    position: absolute;
    right: 12px;
    bottom: 11px;
    line-height: 1;
  }
`;

export default {
  Text,
};
